class ParallaxComponent{

  constructor(parallaxSelector){
    this.document = document.documentElement;
    this.elements = document.querySelectorAll(parallaxSelector);
    this.defaultSoftness = 12;

    this.softness = null;
    this.transitionProperty = null;

    this.initParallaxHandler();

  }

  initParallaxHandler(){

    for(const el of this.elements){
      this.transitionProperty = getComputedStyle(el).transition;

      el.style.transition = this.transitionProperty.length > 0 ? `${this.transitionProperty}, transform 1s ease-out` :  el.style.transition = `transform 1s ease-out`;
    }

    let scrollTop = window.pageYOffset || this.document.scrollTop;

    window.addEventListener('scroll', () => {
      scrollTop = window.pageYOffset || this.document.scrollTop;
      for(const el of this.elements){
        let softness = typeof el.dataset.parallaxSoftness !== "undefined" ? el.dataset.parallaxSoftness : this.defaultSoftness;

        if(this.isInViewport(el)){
          el.style.transform = `translateY(-${scrollTop / softness}px)`;
        }
      }
    });


  }

  isInViewport(el){
    let rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      //rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}

export default ParallaxComponent;